import { render, staticRenderFns } from "./LineItemDialog.vue?vue&type=template&id=4e0455a2"
import script from "./LineItemDialog.vue?vue&type=script&lang=js"
export * from "./LineItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports